import { IInboxMessagePreview } from '@trycourier/react-provider';
import {
  decodeOrganizationIdFromCourierTags,
  DIRECT_MESSAGE,
  extractNanoId,
  findOrganizationIdTag,
  IInboxMessagePreviewWithTags,
  nanoPrefix,
} from 'shared/src/courier/organizationTagUtils';

const isSentToCurrentOrg = (message: IInboxMessagePreviewWithTags, organizationId: string): boolean => {
  const organizationTag = findOrganizationIdTag(message) ?? '';
  const decodedTag = decodeOrganizationIdFromCourierTags(organizationTag);

  return organizationTag.includes(nanoPrefix)
    ? decodedTag === extractNanoId(organizationId)
    : decodedTag === organizationId;
};

const isDirect = (message: IInboxMessagePreviewWithTags): boolean =>
  !!message.tags?.find((tag): boolean => tag === DIRECT_MESSAGE);

const hasNoTags = (message: IInboxMessagePreviewWithTags): boolean =>
  !message.tags || message.tags.length === 0;

export function filterCurrentOrganizationAndDirectMessages(
  organizationId: string,
  messages?: IInboxMessagePreview[],
): IInboxMessagePreviewWithTags[] {
  // This is dodgy as fuck. Courier **actually does deliver tags** inside the message, 
  // but their SDK type doesn't have it,
  // i.e. it could theoretically disappear at any moment.
  const messagesWithTags = messages as IInboxMessagePreviewWithTags[] | undefined;

  return messagesWithTags?.filter((message) =>
    isSentToCurrentOrg(message, organizationId) || isDirect(message) || hasNoTags(message),
  ) ?? [];
}
